/* eslint-disable no-prototype-builtins */
import React, { useState } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useBusinessToolsContext, useCommonContext, } from '../../hooks/useContexts';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import { BusinessToolsErrorMessage } from './BuisnessToolsErrorMessage';
import { GetTopSpendByDepartment } from '../../hooks/business-tools-hooks';
import { spendPercentage } from '../../utils/business-tools';
import { DateRanges } from '../../utils/DateRanges';
import { getSvocId } from '../../utils/user';
import '../../styles/business-tools.scss';
import { SpendByDepartmentSkeleton } from './BusinessToolsSkeletons';
var colorKeyValuePair = {
    0: '#F96302',
    1: '#ff8364',
    2: '#fdb87d',
    3: '#d7bfab',
    4: '#ffe8d5',
};
var getBarWidth = function (percentageSpent) {
    if (percentageSpent <= 0.5) {
        return percentageSpent > 0 ? '0.5%' : '0%';
    }
    return "".concat(percentageSpent, "%");
};
// map over array and return html and values
var spendByDepartmentList = function (spendByDepartmentData, showMoreDepartments, redirectQueryParams, businessToolsHostName) {
    var denominatorAmount = spendByDepartmentData[0];
    return spendByDepartmentData.map(function (data, i) {
        var percentageSpent = spendPercentage(denominatorAmount.totalSpend, data.totalSpend);
        if (showMoreDepartments === 0 && i > 4) {
            return true;
        }
        if (data.hasOwnProperty('totalSpend')) {
            /**
             * This is the data for linking to other page (purchase history) with search params
             */
            var redirectUrl = redirectQueryParams.startDate
                ? "".concat(businessToolsHostName, "?requestSearchSelectorValue=departmentNumber&requestSearchCriteria=").concat(data.deptNumber, "&startDate=").concat(redirectQueryParams.startDate, "&endDate=").concat(redirectQueryParams.endDate, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue)
                : "".concat(businessToolsHostName, "?requestSearchSelectorValue=departmentNumber&requestSearchCriteria=").concat(data.deptNumber, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue);
            if ((redirectQueryParams === null || redirectQueryParams === void 0 ? void 0 : redirectQueryParams.poJobName) !== 'all') {
                Object.assign(redirectQueryParams, {
                    searchBy: [
                        {
                            departmentNumber: data.deptNumber,
                            POJobName: redirectQueryParams === null || redirectQueryParams === void 0 ? void 0 : redirectQueryParams.poJobName,
                        },
                    ],
                });
            }
            var operator = data.totalSpend < 0 ? '-' : '';
            return (React.createElement("li", { className: "sui-list-none sui-my-3", key: i },
                React.createElement("div", { 
                    // TODO: Change to button once CPS can redirect with proper data. No ETA on this
                    // type="button"
                    // onClick={() => {
                    //   if (getWindow()) {
                    //     const location = getWindow()?.location;
                    //     location?.assign(redirectUrl);
                    //   }
                    // }}
                    className: "sui-block", style: { width: '100%' } },
                    React.createElement("div", { className: "business-tools__Labels u__flex" },
                        React.createElement("span", null, data.deptName !== ''
                            ? data.deptName
                            : 'Department name unavailable'),
                        React.createElement("span", null, "".concat(operator, "$").concat(Math.abs(data.totalSpend).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                        })))),
                    React.createElement("div", null,
                        React.createElement("div", { style: {
                                backgroundColor: colorKeyValuePair[i]
                                    ? colorKeyValuePair[i]
                                    : '"#cccccc"',
                                width: getBarWidth(percentageSpent),
                                height: 15,
                            } })))));
        }
        return React.createElement(React.Fragment, null);
    });
};
var renderSpendByDepartmentElement = function (jobDepartmentData, jobDepartmentError, jobDepartmentLoaded, redirectQueryParams, spendByDeptState, businessToolsHostName) {
    var _a, _b;
    if (jobDepartmentLoaded) {
        if (jobDepartmentError) {
            return BusinessToolsErrorMessage();
        }
        if (jobDepartmentData &&
            jobDepartmentData.businessToolsResponse.deptsSpend.length > 0) {
            return (React.createElement(React.Fragment, null,
                ' ',
                React.createElement("div", { className: "business-tools__fullWidth u__flex business-tools__subHeader business-tools__marginTop" },
                    React.createElement("h4", null, "Highest to Lowest")),
                React.createElement("div", { className: "jobs u__clearfix" },
                    React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-2" },
                        React.createElement("ul", { className: "department-list", style: { width: '100%' } }, spendByDepartmentList(jobDepartmentData.businessToolsResponse.deptsSpend, spendByDeptState.showMoreDepartments, redirectQueryParams, businessToolsHostName)),
                        ((_b = (_a = jobDepartmentData === null || jobDepartmentData === void 0 ? void 0 : jobDepartmentData.businessToolsResponse) === null || _a === void 0 ? void 0 : _a.deptsSpend) === null || _b === void 0 ? void 0 : _b.length) >
                            5 ? (React.createElement("div", { className: "business-tools__rmPaddingLeft" }, spendByDeptState.hideMe ? (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showMoreDepartmentsElement", onClick: function () {
                                spendByDeptState.setShowMoreDepartments(1);
                                spendByDeptState.setHideMe(false);
                            } },
                            React.createElement("span", { className: "bttn__content" }, "Show more departments"))) : (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showLessDepartmentsElement", onClick: function () {
                                spendByDeptState.setShowMoreDepartments(0);
                                spendByDeptState.setHideMe(true);
                            } },
                            React.createElement("span", { className: "bttn__content" }, "Show less"))))) : ('')))));
        }
        return (React.createElement(Typography, { weight: "bold" }, "No records can be found for the selected date range and/or job name."));
    }
    return React.createElement(SpendByDepartmentSkeleton, null);
};
export var SpendByDepartment = function () {
    var dateRangeOptions = useCommonContext().dateRangeOptions;
    var _a = useBusinessToolsContext(), dateSelectorValue = _a.dateSelectorValue, requestData = _a.requestData, businessToolsHostName = _a.businessToolsHostName;
    var _b = useState(0), showMoreDepartments = _b[0], setShowMoreDepartments = _b[1];
    var _c = useState(true), hideMe = _c[0], setHideMe = _c[1];
    var request = {
        businessToolsRequest: {
            startDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.startDate
                : DateRanges[dateSelectorValue].startDate,
            endDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.endDate
                : DateRanges[dateSelectorValue].endDate,
            jobName: requestData.poJobName,
        },
        customerAccountId: getSvocId() || '',
    };
    var redirectQueryParams = {
        startDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.startDate
            : DateRanges[dateSelectorValue].startDate,
        endDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.endDate
            : DateRanges[dateSelectorValue].endDate,
        dateSelectorValue: dateSelectorValue || 'YTD',
        poJobName: requestData.poJobName || '',
    };
    var spendByDeptState = {
        showMoreDepartments: showMoreDepartments,
        setShowMoreDepartments: setShowMoreDepartments,
        hideMe: hideMe,
        setHideMe: setHideMe,
    };
    var _d = GetTopSpendByDepartment(request), jobDepartmentData = _d.jobDepartmentData, jobDepartmentLoaded = _d.jobDepartmentLoaded, jobDepartmentError = _d.jobDepartmentError;
    return (React.createElement("div", { className: "spend-department" },
        React.createElement(SectionHeader, { title: "Spend By Department" }),
        renderSpendByDepartmentElement(jobDepartmentData, jobDepartmentError, jobDepartmentLoaded, redirectQueryParams, spendByDeptState, businessToolsHostName)));
};
